<template>
  <span
    :style="{
      display: form ? 'flex' : 'inline-block',
      position: 'relative',
      width: form ? '100%' : 'auto',
    }"
    @mouseenter="move"
    @mouseleave.stop="leave"
  >
    <span class="text-15px" :class="{ 'mr-5px': startText }">{{ startText }}</span>
    <el-date-picker
      class="mr-10px"
      v-model="startTime"
      :format="format"
      size="small"
      :type="type"
      :style="{
        width: inputWidth,
        flex: form ? '1' : 'none',
        height: inputHeight,
      }"
      :disabled="disabled"
      :editable="false"
      :clearable="false"
      @change="timeChange"
      :picker-options="startTimeOption"
      :placeholder="startPlaceholder"
    >
    </el-date-picker>
    <span
      class="ml-5px mr-5px text-14px"
      :style="{
        flex: form ? '20px 0' : 'none',
      }"
      >至</span
    >
    <span class="text-15px mr-5px">{{ endText }}</span>
    <el-date-picker
      size="small"
      v-model="endTime"
      @change="timeChange"
      :format="format"
      :disabled="disabled"
      :style="{
        width: inputWidth,
        flex: form ? '1' : 'none',
        height: inputHeight,
      }"
      :type="type"
      :clearable="false"
      :picker-options="endTimeOption"
      :editable="false"
      :placeholder="endPlaceholder"
    >
    </el-date-picker>
    <span
      class="el-input__icon el-icon-circle-close icon_close cursor-pointer"
      @click="clear"
      v-show="iconShow && !disabled"
    ></span>
  </span>
</template>

<script>
export default {
  /* eslint-disable */

  data() {
    return {
      type: 'datetime',
      id: 0,
      // 控制model watch 执行次数
      modelFlag: true,
      // 是不是 el-form元素包裹
      form: false,
      startTime: null,
      endTime: null,
      // eslint-disable-next-line
      startTimeOption: null,
      // eslint-disable-next-line
      endTimeOption: null,
      selectStartTime: '',
      parent: this.$parent,
      ref: null,
      clearIconShow: false,
    }
  },
  computed: {
    iconShow() {
      return this.clearIconShow && this.clearable
    },
  },
  props: {
    // 绑定的数据
    model: {
      required: true,
    },
    // 数据-字符串
    modelName: {
      type: String,
      default() {
        return ''
      },
    },
    className: {
      type: String,
      default() {
        return null
      },
    },
    // 开始时间文本
    startText: {
      type: String,
      default() {
        return ''
      },
    },
    // 结束时间文本
    endText: {
      type: String,
      default() {
        return ''
      },
    },
    // 开始时间 空选值
    startPlaceholder: {
      type: String,
      default() {
        return '请选择开始时间'
      },
    },
    // 结束时间 空选值
    endPlaceholder: {
      type: String,
      default() {
        return '请选择结束时间'
      },
    },
    valueFormat: {
      type: String,
      default() {
        return 'YYYY-MM-DD HH:mm:ss'
      },
    },
    format: {
      type: String,
      default() {
        return 'yyyy-MM-dd HH:mm:ss'
      },
    },
    // 禁用 今天 之前的 日期
    disabledBeforeToday: {
      type: Boolean,
      default() {
        return false
      },
    },
    // 禁用 今天 之后的 日期
    disabledAfterToday: {
      type: Boolean,
      default() {
        return false
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
    inputWidth: {
      type: String,
      default() {
        return '140px'
      },
    },
    clearable: {
      type: Boolean,
      default() {
        return true
      },
    },
    inputHeight: {
      type: String,
      default() {
        return 'auto'
      },
    },
    // 解决 bug el-tab 组件循环过多
    isRepeat: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  watch: {
    model(val, oldVal) {
      if (this.$parent.$dateTimeStop) {
        // debugger
        this.$parent.$dateTimeCount = 0
        return
      }
      this.$parent.$dateTimeCount += 1
      // while(true) {
      //   this.$parent.$dateTimeCount += 1
      // 错误 处理
      if (this.$parent.$dateTimeCount > 50) {
        console.warn(`恭喜你, 发现了时间选择器的最大彩蛋(bug)' +
        '请告诉我(钟宁) 或者到${window.location.origin}/#/demo/date-time处查看`)
        setTimeout(() => {
          this.$parent.$dateTimeCount = 0
        }, 500)
        return
      }
      // }
      // console.log('newVal', val)
      // console.log('oldVal', oldVal)
      // console.log('modelFlag', this.modelFlag)
      // debugger
      if (!_.isEmpty(val) === !_.isEmpty(oldVal) && !this.modelFlag) {
        // 死循环 bug
        if (this.isRepeat) {
          // debugger
          this.$parent.$dateTimeStop = true
          setTimeout(() => {
            this.$parent.$dateTimeStop = false
            this.$parent.$dateTimeCount = 0
          }, 1000)
        }
        this.modelFlag = true
        return
      }
      if (_.isArray(val) && _.isEmpty(val)) {
        const flag = this.clearable
        this.clearable = true
        this.startTime = null
        this.endTime = null
        this.modelFlag = false
        this.$nextTick(() => {
          this.clearable = flag
          this.ref.$set(this.ref, this.modelName, [])
        })
      } else {
        this.modelFlag = true
        this.startTime = val[0]
        this.endTime = val[1]
      }
    },
    startTime(val) {
      if (val == null && this.clearable) {
        // this.ref[this.modelName] = null
        this.ref.$set(this.ref, this.modelName, [])
      } else if (val == null) {
        this.startTime = this.endTime
        this.model[0] = moment(this.endTime).format(this.valueFormat)
      } else {
        if (_.isNil(this.model)) {
          this.ref.$set(this.ref, this.modelName, [])
          this.startTime = val
          this.endTime = val
        }
        // this.ref.$set(this.ref, , [])
        this.$nextTick(() => {
          this.model[0] = moment(val).format(this.valueFormat)
        })
      }
    },
    endTime(val) {
      if (val == null && this.clearable) {
        this.ref.$set(this.ref, this.modelName, [])
        this.startTime = null
      } else if (val == null) {
        this.endTime = this.startTime
        this.model[1] = moment(this.startTime).format(this.valueFormat)
      } else {
        if (_.isNil(this.model)) {
          this.ref.$set(this.ref, this.modelName, [])
          // this.model = []
          this.startTime = val
          this.endTime = val
        }
        this.$nextTick(() => {
          this.model[1] = moment(val).format(this.valueFormat)
        })
      }
    },
  },
  methods: {
    clear() {
      // 对象嵌套的 形式
      if (this.modelName.indexOf('.') >= 0) {
        let obj
        const parameter = this.modelName.split('.')
        const lastParameter = parameter.pop()
        _.forEach(parameter, (i, index) => {
          if (index === 0) {
            obj = this.ref[parameter[0]]
          } else {
            obj = obj[parameter[index]]
          }
        })
        obj[lastParameter] = []
      }
      this.endTime = null
    },
    move() {
      if (!_.isNil(this.startTime) && !_.isNil(this.endTime)) {
        this.clearIconShow = true
      }
    },
    leave() {
      this.clearIconShow = false
    },
    getTime() {
      if (!_.isNil(this.startTime) && !_.isNil(this.endTime)) {
        return [
          moment(this.startTime).format(this.valueFormat),
          moment(this.endTime).format(this.valueFormat),
        ]
      }
      return []
    },
    // eslint-disable-next-line
    selfStartTimeOption() {
      const that = this
      if (this.disabledBeforeToday) {
        return {
          disabledDate(time) {
            if (!_.isNil(that.endTime)) {
              return (
                moment(time).format('YYYYMMDD') * 1 > moment(that.endTime).format('YYYYMMDD') * 1 ||
                moment().format('YYYYMMDD') * 1 > moment(time).format('YYYYMMDD') * 1
              )
            }
            return moment().format('YYYYMMDD') * 1 > moment(time).format('YYYYMMDD') * 1
          },
        }
        // eslint-disable-next-line
      } else if (this.disabledAfterToday) {
        return {
          disabledDate(time) {
            if (!_.isNil(that.endTime)) {
              return (
                moment(time).format('YYYYMMDD') * 1 > moment(that.endTime).format('YYYYMMDD') * 1
              )
            }
            return moment().format('YYYYMMDD') * 1 < moment(time).format('YYYYMMDD') * 1
          },
        }
        // eslint-disable-next-line
      } else {
        return {
          disabledDate(time) {
            if (!_.isNil(that.endTime)) {
              return (
                moment(time).format('YYYYMMDD') * 1 > moment(that.endTime).format('YYYYMMDD') * 1
              )
            } else {
              return false
            }
          },
        }
      }
      // else if (!_.isEmpty(that.endTime)) {
      //   return {
      //     disabledDate(time) {
      //       console.log('this.endTime', that.endTime)
      //       return moment(time).format('YYYYMMDD') * 1 > moment(that.endTime).format('YYYYMMDD') * 1
      //     }
      //   }
      // }
    },
    selfEndTimeOption() {
      const that = this
      return {
        disabledDate(time) {
          if (that.disabledAfterToday) {
            if (!_.isNil(that.startTime)) {
              return (
                moment(time).format('YYYYMMDD') * 1 <
                  moment(that.startTime).format('YYYYMMDD') * 1 ||
                moment().format('YYYYMMDD') * 1 < moment(time).format('YYYYMMDD') * 1
              )
            }
            return moment().format('YYYYMMDD') * 1 < moment(time).format('YYYYMMDD') * 1
          }
          if (that.disabledBeforeToday) {
            return moment().format('YYYYMMDD') * 1 > moment(time).format('YYYYMMDD') * 1
          }
          if (!_.isNil(that.startTime)) {
            return (
              moment(time).format('YYYYMMDD') * 1 < moment(that.startTime).format('YYYYMMDD') * 1
            )
          }
          // return moment().format('YYYYMMDD') * 1 < moment(time).format('YYYYMMDD') * 1
          return false
        },
      }
    },
    timeChange() {
      // if (_.isNil(this.startTime)) {
      //   this.startTime = null
      // }
      // if (_.isNil(this.endTime) && this.clearable && !_.isNil(this.startTime)) {
      //   this.startTime = null
      //   this.endTime = null
      // }
      // else {
      //   this.endTime = null
      // }
      // 开始时间 大于 结束时间
      if (
        !_.isNil(this.startTime) &&
        !_.isNil(this.endTime) &&
        this.startTime.getTime() > moment(this.endTime).valueOf()
      ) {
        this.startTime = this.endTime
      }
      if (_.isNil(this.startTime)) {
        this.startTime = this.endTime
      }
      if (_.isNil(this.endTime)) {
        this.endTime = this.startTime
      }
      // 开始时间 和 结束时间 都有 对外触发change 事件
      if (!_.isNil(this.startTime) && !_.isNil(this.endTime)) {
        this.$emit('change', [
          moment(this.startTime).format(this.valueFormat),
          moment(this.endTime).format(this.valueFormat),
        ])
      }
    },
    // eslint-disable-next-line
    findParentData(obj = this.$parent) {
      this.parent = obj
      let result
      let modelName = this.modelName
      if (this.modelName.indexOf('.') >= 0) {
        modelName = this.modelName.split('.').shift()
      }
      // if (this.className && obj.$el.className.indexOf(this.className) === -1) {
      //   result = this.findParentData(this.parent.$parent)
      // } else if (this.className) {
      //   return this.parent[`${this.modelName}`] ? this.parent : this.parent.$parent
      // }
      // if (obj.$el.className.indexOf('el-') !== -1 && _.isNil(this.className)) {
      //   result = this.findParentData(this.parent.$parent)
      // } else if (_.isNil(this.className)) {
      //   return this.parent
      // }
      if (!this.parent[modelName] && _.isNil(this.className)) {
        result = this.findParentData(this.parent.$parent)
      }
      return this.parent
    },
  },
  created() {
    this.$parent.$dateTimeCount = 0
    if (this.model && this.model[0]) {
      // eslint-disable-next-line
      this.startTime = moment(this.model[0]).format(this.valueFormat)
    }
    if (this.model && this.model[1]) {
      // eslint-disable-next-line
      this.endTime = moment(this.model[1]).format(this.valueFormat)
    }
    this.startTimeOption = this.selfStartTimeOption()
    // eslint-disable-next-line
    this.endTimeOption = this.selfEndTimeOption()
    // 判断 是不是被el-form 组件包裹
    if (this.$parent['elForm']) {
      this.form = true
    }
  },
  mounted() {
    if (this.format.indexOf('HH:mm:ss') > 0) {
      this.type = 'datetime'
    } else {
      this.type = 'date'
    }
    console.error('type', this.type)
    console.warn(`时间选择器demo地址: ${window.location.origin}/#/demo/date-time`)
    // 错误参数 判断
    if (!(this.model instanceof Array)) {
      console.error('dateTime组件初始化失败,请确保model属性是array类型')
      return
    }
    if (!_.isNil(this.className)) {
      console.warn('class-name 属性已弃用, 请删除')
    }
    try {
      this.ref = this.findParentData()
    } catch (e) {
      if (e === 'RangeError: Maximum call stack size exceeded') {
        console.error(
          'dateTime组件初始化失败, 请确保model-name属性和model保持一致,例如model=obj.time, model-name="obj.time"'
        )
      } else {
        console.error(e)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

.fz-15 {
  font-size: 15px;
}
.icon_close {
  position: absolute;
  right: 4px;
  // top: calc(50% - 16px);
  line-height: 25px;
}

</style>
